module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtLTQwLjYgMzYuM0wxMTYuNCA2NjIuNEE0OCA0OCAwIDAgMCAxNTcgNzM2aDcxMGE0OCA0OCAwIDAgMCA0MC42LTczLjZMNTUyLjYgMTAwLjNhNDggNDggMCAwIDAtODEuMiAwek01MTIgMTU1LjlMODM4IDY3MkgxODZMNTEyIDE1NS45eiIgZmlsbD0iIzAiIHAtaWQ9IjQyOTQiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/API-filled.svg
// module id = LyyN
// module chunks = 73